'use client';

import { useEffect } from 'react';

import { Button } from '@extern/ui/button';
import { Text } from '@extern/ui/text';
import Image from 'next/image';
import Link from 'next/link';

import { DEFAULT_LOGGED_PAGE } from '@/infra/constants/routes';
import { ErrorTracking } from '@/lib/error-tracking';

interface GlobalErrorProps {
  error: Error;
  reset: () => void;
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    ErrorTracking.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        <div className="mt-[-56px] flex min-h-screen min-w-full flex-col items-center justify-center bg-white">
          <div className="flex max-w-[620px] flex-1 flex-col items-center justify-center gap-4 p-4">
            <Image
              alt="People talking in a reference to a 404 page"
              height={406}
              src="/images/error-general.png"
              width={406}
            />

            <Text heading="xl">Oh, no!</Text>
            <Text body="lg" className="text-center font-normal text-base text-gray-dark leading-8">
              Looks like we&apos;re facing some difficulties.
              <br />
              If the error persists, please reach out to
              <br />
              <a
                className="font-medium text-blue-dark"
                href="mailto:support@extern.com"
                rel="noreferrer"
                target="_blank">
                support@extern.com
              </a>
            </Text>

            <Button asChild>
              <Link href={DEFAULT_LOGGED_PAGE}>Go back to Home</Link>
            </Button>

            <Button appearance="ghost" onClick={() => reset()}>
              Try again
            </Button>
          </div>
        </div>
      </body>
    </html>
  );
}
